import { toast } from 'react-toastify';
import { notification } from '../constants/constants';

const paramsDefault = {
position: 'top-right',
autoClose: 3000,
hideProgressBar: true,
closeOnClick: true,
pauseOnHover: false,
draggable: true,
progress: undefined,
icon: false
};

const paramsError = {
position: 'top-right',
autoClose: false,
hideProgressBar: true,
closeOnClick: false,
pauseOnHover: true,
draggable: false,
progress: undefined,
icon: false
};

export function showSuccess(message = notification.SUCCESS) {
toast.success(message, paramsDefault);
}

export function showError(error) {
const message =
error?.message ||
error?.data?.message ||
error?.data?.errorMessage ||
error?.data?.Message ||
notification.ERROR;

toast.error(message, paramsError);
}

export function showWarning(message) {
toast.warning(message, paramsDefault);
}